module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/genius.2c2f8def.png";